import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import {
  Title,
  DailyItem,
  IconSmall,
  Day,
  Description,
  MinMax,
  DailyDetailsGrid,
  DailyDetailsGridItem,
} from "./Forecast.styled";

const WEEK_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const Forecast = ({ data }) => {
  const dayInAWeek = new Date().getDay();
  const forecastDays = WEEK_DAYS.slice(dayInAWeek, WEEK_DAYS.length).concat(
    WEEK_DAYS.slice(0, dayInAWeek)
  );

  return (
    <>
      <Title>Daily</Title>
      <Accordion allowZeroExpanded>
        {data.list.splice(0, 7).map((item, idx) => (
          <AccordionItem key={idx}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <DailyItem>
                  <IconSmall
                    src={`icons/${item.weather[0].icon}.png`}
                    alt="weather"
                  />
                  <Day>{forecastDays[idx]}</Day>
                  <Description>{item.weather[0].description}</Description>
                  <MinMax>
                    {window.screen.width <= 760 ? (
                      <p> {Math.round(item.main.temp_max)}°C</p>
                    ) : (
                      <p>
                        {item.main.temp_max}°C Max /{item.main.temp_min}°C Min
                      </p>
                    )}
                  </MinMax>
                </DailyItem>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <DailyDetailsGrid>
                <DailyDetailsGridItem>
                  <label>Pressure:</label>
                  <label>{item.main.pressure}</label>
                </DailyDetailsGridItem>
                <DailyDetailsGridItem>
                  <label>Humidity:</label>
                  <label>{item.main.humidity}</label>
                </DailyDetailsGridItem>
                <DailyDetailsGridItem>
                  <label>Clouds:</label>
                  <label>{item.clouds.all}%</label>
                </DailyDetailsGridItem>
                <DailyDetailsGridItem>
                  <label>Wind speed:</label>
                  <label>{item.wind.speed} m/s</label>
                </DailyDetailsGridItem>
                <DailyDetailsGridItem>
                  <label>Sea level:</label>
                  <label>{item.main.sea_level}m</label>
                </DailyDetailsGridItem>
                <DailyDetailsGridItem>
                  <label>Feels like:</label>
                  <label>{item.main.feels_like}°C</label>
                </DailyDetailsGridItem>
              </DailyDetailsGrid>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
};

export default Forecast;
